<template>
    <div v-if="appear" @click="flip = !flip">
        <transition name="flip" mode="out-in">
            <figure v-if="flip" class="bg-white shadow-md flex flex-col justify-center w-full h-full" key="front">
                <svg class="outlineAnimation" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 41.49 30.5"><title>photo_stroke</title>
                    <g id="3e235136-6dd8-425d-9e10-a3263d77c9ba" data-name="Layer 2">
                        <g id="b1e56b36-be3a-494b-84ef-95c785a11479" data-name="Layer 1">
                            <path d="M36.25,11.25v-10a1,1,0,0,0-1-1h-34a1,1,0,0,0-1,1v23a1,1,0,0,0,1,1h26"
                                  fill="none" stroke="#69AE45" stroke-linecap="round" stroke-linejoin="round"
                                  stroke-width="0.5"/>
                            <path d="M27.24,25.25h-26a1,1,0,0,1-1-1v-2H27.51" fill="none" stroke="#69AE45"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <polyline points="16.35 29.25 12.25 29.25 12.25 30.25 24.25 30.25 24.25 29.25 22.25 29.25 21.25 25.25 15.25 25.25 14.25 29.25"
                                    fill="none" stroke="#69AE45" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="0.5"/>
                            <path d="M31.24,21.25a.5.5,0,0,0-1,0h-1a2,2,0,0,0-2,2v6a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1v-6a2,2,0,0,0-1.92-2h-.08l-.72-1.09a1.09,1.09,0,0,0-.9-.41H34.86a1.09,1.09,0,0,0-.9.41l-.72,1.09Z"
                                  fill="none" stroke="#69AE45" stroke-linecap="round" stroke-linejoin="round"
                                  stroke-width="0.5"/>
                            <circle cx="35.74" cy="25.75" r="3.5" fill="none" stroke="#69AE45" stroke-linecap="round"
                                    stroke-linejoin="round" stroke-width="0.5"/>
                            <path d="M36.71,23.45a2.5,2.5,0,1,1-2.78,4" fill="none" stroke="#69AE45"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <rect x="32.74" y="11.25" width="7" height="4" rx="1" ry="1" fill="none" stroke="#69AE45"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <path d="M39.54,16.25l-.25,1.56a.5.5,0,0,1-.49.44H33.68a.5.5,0,0,1-.49-.44l-.45-3.56"
                                  fill="none" stroke="#69AE45" stroke-linecap="round" stroke-linejoin="round"
                                  stroke-width="0.5"/>
                            <line x1="36.24" y1="18.25" x2="36.24" y2="19.75" fill="none" stroke="#69AE45"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <path d="M1.44,17.25l9-8.11a1.57,1.57,0,0,1,2-.06l8.17,6.54a1.4,1.4,0,0,0,1.63.07l4.45-3a1.22,1.22,0,0,1,1.4,0L33,16.43"
                                  fill="none" stroke="#69AE45" stroke-linecap="round" stroke-linejoin="round"
                                  stroke-width="0.5"/>
                            <circle cx="22.44" cy="8.25" r="1.5" fill="none" stroke="#69AE45" stroke-miterlimit="10"
                                    stroke-width="0.5"/>
                        </g>
                    </g>
                </svg>
                <h1 class="font-hairline text-xl text-center mt-6">Fotózás</h1>
            </figure>
            <figure v-else class="shadow-md card flex flex-col justify-center w-full h-full bg-v-green" key="back">
                <span class="font-light xl:font-hairline font-fira text-white leading-normal p-8">Professzionális fotós tartalom készítése a maximális összhangért és minőségért. Termék fotók, üzleti portré és headshot fotók, ingatlan fotózás kívül-belül, kreatív anyagok befotózása.
                </span>
            </figure>
        </transition>
    </div>

</template>

<script>
export default {
  props: ['svg', 'appear'],
  data () {
    return {
      flip: true
    }
  }
}
</script>

<style scoped>
    .outlineAnimation {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
        animation: icon-animate-in 2s cubic-bezier(0.95, 0.05, 0.795, 0.035);
    }

    @keyframes icon-animate-in {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffest: 0;
        }
    }

    svg {
        height: 5rem;
    }
    figure {
        border-radius: 10px;
    }
    .flip-enter-active, .flip-leave-active {
        transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    .flip-enter, .flip-leave-to {
        transform: rotateY(90deg);
        opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Fotozas.vue